const IS_PRODUCTION = () => !/staging|localhost/i.test(window.location.href);

export const HIPPOCRATES_URL = IS_PRODUCTION()
? "https://hippocrates.production.botmd.io"
: "https://hippocrates.staging.botmd.io"; 

export const SITE_KEY = IS_PRODUCTION()
? "6Lceg_wZAAAAALqT_Ru3FbOiH1j8qP90OOvBReKY"
: "6LcMRPwZAAAAAL9WWPjNhz4GvtAUMMu3hdyvDISf";
